export enum UserRoleType {
  None,
  Admin,
  SystemService,
  SuperUser,
  User,
  Agent,
}

export enum IdentityStatus {
  SignIn,
  Authenticated,
  AccessDenied,
  Blocked,
  Activation,
  Registration,
}

export enum ActivationErrorCode {
  Invalid = 2010,
  NotFound = 2020,
  Inactive = 2030,
  Expired = 2040,
  Unexpected = 2099,
}

export enum RegisterErrorCode {
  InvalidClient = 3010,
  InvalidRole = 3011,
  InvalidSession = 3012,
  InvalidEmail = 3013,
  TemplateNotFound = 3020,
  UnverifiedSessionNotFound = 3030,
  UserLimit = 3040,
  Unexpected = 3099,
}

export enum UserErrorCode {
  InvalidClient = 4010,
  InvalidView = 4015,
  InvalidRole = 4020,
  InvalidDomain = 4030,
  SettingAutoCreateDisabled = 4031,
  TemplateUserNotFound = 4032,
  InvalidEmail = 4035,
  InvalidSession = 4040,
  InvalidAccess = 4045,
  Unexpected = 4099,
}
